import * as React from "react";
import { Icon, Link, Stack, Text } from "office-ui-fabric-react";

interface IFaqItem {
  question: string;
  answer: React.ReactNode;
  iconName: string;
}

const faqItems: IFaqItem[] = [
  {
    question: "I am a dentist/dental technician. Can I get access?",
    answer: (
      <>
        This portal is restricted to certified third-party planning software partners. Dentists and end customers cannot request STL library access through this
        workflow.
      </>
    ),
    iconName: "Cancel",
  },
  {
    question: "How long does approval take?",
    answer: (
      <>
        After your account is activated and the signed legal agreement is uploaded, Straumann reviews the submission and notifies you by email. The turnaround
        depends on the completeness of the request and current review volume.
      </>
    ),
    iconName: "Clock",
  },
  {
    question: "Who can I contact for support?",
    answer: (
      <>
        For STL library content questions, contact <Link href="mailto:STL_Library_Request@straumann.com">STL_Library_Request@straumann.com</Link>. For account
        activation, watch for messages from <Link href="mailto:app_azure@straumann.com">app_azure@straumann.com</Link>.
      </>
    ),
    iconName: "Mail",
  },
];

export const FaqSection = (): React.ReactElement => {
  const [expandedQuestion, setExpandedQuestion] = React.useState<string | null>(null);

  return (
    <Stack className="welcomeInfoCard welcomeFaqSection" tokens={{ childrenGap: 0 }}>
      <Text variant="xLarge" className="welcomeInfoCardTitle welcomeFaqTitle">
        FAQ
      </Text>
      <Stack as="ul" className="welcomeFaqList" tokens={{ childrenGap: 0 }}>
        {faqItems.map((item) => {
          const isExpanded = expandedQuestion === item.question;

          return (
            <li key={item.question} className={`welcomeFaqListItem ${isExpanded ? "welcomeFaqListItemExpanded" : ""}`}>
              <button
                type="button"
                className="welcomeFaqButton"
                aria-expanded={isExpanded}
                onClick={() => setExpandedQuestion(isExpanded ? null : item.question)}
              >
                <div className="welcomeFaqButtonContent">
                  <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 14 }} className="welcomeFaqButtonLabel">
                    <Icon iconName={item.iconName} className="welcomeFaqIcon" />
                    <Text variant="large" className="welcomeFaqQuestion">
                      {item.question}
                    </Text>
                  </Stack>
                  <Icon iconName={isExpanded ? "ChevronUp" : "ChevronDown"} className="welcomeFaqChevron" />
                </div>
              </button>
              {isExpanded && <div className="welcomeFaqAnswer">{item.answer}</div>}
            </li>
          );
        })}
      </Stack>
    </Stack>
  );
};
